import { v4 as randomUuid } from "uuid";

const Uuid = { generate };

function generate() {
  return randomUuid();
}

export default Uuid;
